<form class="screen-w-full">
	<lgb-logo/>
	<fieldset class="fieldset border-base-300 rounded-box w-xs border p-4 glass">
  		<legend class="fieldset-legend">Login</legend>
		<lgb-message [(msg)]="msg" [(error)]="error"></lgb-message>
		<label class="floating-label my-3">
			<span>E-mail</span>
			<input type="text" name="email" placeholder="mail@site.com" class="input input-md" [(ngModel)]="mail" email required/>
		</label>
		<label class="floating-label mb-3">
			<span>Mot de passe</span>
			<input type="password" name="pass" placeholder="Mot de passe" class="input input-md" [(ngModel)]="pass" required />
		</label>
		<button (click)="connect()" class="btn btn-primary btn-gradient mb-3">Login</button>
		<div class="links">
			<a href="#" [routerLink]="router.get('forgot')" class="text-primary">Mot de passe oublié ?</a>
			<a href="#" [routerLink]="router.get('sign')" class="text-primary">Créer un compte</a>
		</div>
	</fieldset>
</form>